import React, { Component } from "react";
import { connect } from "react-redux";

import Display from "../../../Components/Display";
import { bindActionCreators } from "redux";
import {
  setPerPage,
  setPage,
  sortCustomers
} from "../../../store/customers/actions";
import Pagination from "../../../Components/Pagination";
import LoadingOverlay from "react-loading-overlay";
import { loaderstyle } from "../../../config";
import SortIndicator from "../../../Components/SortIndicator";
import { sortTypes } from "../../../store/customers/reducer";

class CustomersTable extends Component {
  setPage = id => this.props.setPage(id);
  setPerPage = perPage => this.props.setPerPage(perPage);
  sort = e => {
    const sortType = e.target.getAttribute("name");
    this.props.sortCustomers(sortType);
  };

  render() {
    const { customers } = this.props;
    const {
      bookings_sort,
      lifetime_value_sort,
      last_booking_sort,
      last_login_sort,
      name_sort,
      createdAt_sort,
      email_sort
    } = this.props;

    return (
      <div className="booking-table-card">
        <Pagination
          currentPage={this.props.current_page}
          totalPages={this.props.total_pages}
          selectPage={this.props.setPage}
        />
        <Display
          label="Display"
          onChange={this.setPerPage}
          options={[100, 200, 300]}
        />
        <div className="table-responsive">
          <table className="basic-table align-left">
            <thead>
              <tr>
                <th>CID</th>
                <th
                  name={sortTypes.name}
                  className="sorter"
                  onClick={this.sort}
                >
                  Full Name <SortIndicator {...{ [name_sort]: true }} />
                </th>
                <th
                  name={sortTypes.email}
                  className="sorter"
                  onClick={this.sort}
                >
                  Contacts <SortIndicator {...{ [email_sort]: true }} />
                </th>
                <th
                  name={sortTypes.bookings}
                  className="sorter"
                  onClick={this.sort}
                >
                  Bookings <SortIndicator {...{ [bookings_sort]: true }} />{" "}
                </th>
                <th
                  name={sortTypes.lifetime_value}
                  className="sorter"
                  onClick={this.sort}
                >
                  Life Time Value{" "}
                  <SortIndicator {...{ [lifetime_value_sort]: true }} />
                </th>
                <th
                  name={sortTypes.createdAt}
                  className="sorter"
                  onClick={this.sort}
                >
                  Sign up Date <SortIndicator {...{ [createdAt_sort]: true }} />
                </th>
                <th
                  name={sortTypes.last_book_date}
                  className="sorter"
                  onClick={this.sort}
                >
                  Last Booking{" "}
                  <SortIndicator {...{ [last_booking_sort]: true }} />
                </th>
                <th
                  name={sortTypes.last_login}
                  className="sorter"
                  onClick={this.sort}
                >
                  Last Login <SortIndicator {...{ [last_login_sort]: true }} />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {customers.map(c => {
                return <CustomerRow key={c._id.uid} customer={c} />;
              })}
            </tbody>
          </table>
        </div>
        <Pagination
          currentPage={this.props.current_page}
          totalPages={this.props.total_pages}
          selectPage={this.props.setPage}
        />
      </div>
    );
  }
}

class CustomerRow extends Component {
  render() {
    const { customer } = this.props;
    return (
      <tr key={customer._id.uid}>
        <td>{customer._id.uid}</td>
        <td>{customer._id.name}</td>
        <td title={customer._id.email}>
          {customer._id.email}
          {/* <span className="checkmark">
                      <img
                        src="/imgs/icons/checkmark-grey.png"
                        alt="checkmark grey icon"
                        width="15"
                      />
                    </span> */}
          <br />
          {customer._id.phone}
          {/* <span className="checkmark">
                      <img
                        src="/imgs/icons/checkmark-green.png"
                        alt="checkmark grey icon"
                        width="15"
                      />
                    </span> */}
        </td>
        <td>{customer.bookings}</td>
        <td>
          <strong className="bolder">{customer.lifetime_value} EGP</strong>
          <br />
          {/* 3m 12d */}
          {customer.lifetime_period || null}
        </td>
        <td>{customer._id.createdAt}</td>
        <td>{customer.last_book_date}</td>
        <td>{customer._id.last_login}</td>
        <td>
          {customer.last_login_app ? (
            <span className="login-msg using">Using App</span>
          ) : (
            <span className="login-msg">Not Using App</span>
          )}
        </td>
      </tr>
    );
  }
}

const mapStateToProps = state => ({
  customers: state.customers.customers,
  bookings_sort: state.customers.sorting.bookings,
  name_sort: state.customers.sorting[sortTypes.name],
  lifetime_value_sort: state.customers.sorting[sortTypes.lifetime_value],
  createdAt_sort: state.customers.sorting[sortTypes.createdAt],
  last_booking_sort: state.customers.sorting[sortTypes.last_book_date],
  last_login_sort: state.customers.sorting[sortTypes.last_login],
  email_sort: state.customers.sorting[sortTypes.email],
  total_pages: state.customers.total_pages,
  current_page: state.customers.paginationOptions.page,
});

const mapDispatchToProps = dispatch => ({
  setPage: bindActionCreators(setPage, dispatch),
  setPerPage: bindActionCreators(setPerPage, dispatch),
  sortCustomers: bindActionCreators(sortCustomers, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomersTable);
